import React, { useContext, useEffect, useState } from "react";
import {
	Button,
	Form,
	Modal,
	Table
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { LoaderContext } from "../../../App";
import { LS_AUTHORITY_KEY } from "../../../core/constants/common";
import KPIService from "../../../core/service/KPIService";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import UserService from "../../../core/service/UserService";
import Multiselect from "multiselect-react-dropdown";
import Utils from "../../../core/utilities/Utils";
import { BiEdit } from "react-icons/bi";

const ActionMode = {
	FORM: 'FORM',
	VIEW_ACTIONS: 'VIEW_ACTIONS',
	SINGLE_ACTION: 'SINGLE_ACTION',
};

function KPIActionModal({ t, actionToUpdate, kpiId, mode = ActionMode.FORM, onHide, onSave }) {

	const lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const companyId = lsData.profile.company.id;
	const { setLoaderDisplay } = useContext(LoaderContext);
	const [formData, setFormData] = useState(actionToUpdate?.id > 0 ? actionToUpdate : {
		ownerId: companyId,
		name: '',
		description: '',
		timelineStart: '',
		timelineEnd: '',
		assignees: []
	});
	const [validated, setValidated] = useState(false);
	const [users, setUsers] = useState([]);
	const [actions, setActions] = useState([]);
	const [actionMode, setActionMode] = useState(mode ?? ActionMode.FORM);
	const [prevMode, setPrevMode] = useState('');

	useEffect(() => {
		if (actionMode === ActionMode.SINGLE_ACTION) return;

		if (actionMode === ActionMode.VIEW_ACTIONS) {
			fetchActions();
		} else {
			fetchUsers();
		}
	}, [actionMode]);

	const fetchUsers = () => {
		UserService.getUsers(0, 10, '', '', true).then((res) => {
			if (res.status !== 200) return;

			setUsers(res.data);
		})
			.catch((error) => {
			});
	};

	const fetchActions = () => {
		if (actionMode !== ActionMode.VIEW_ACTIONS) return;

		KPIService.getActions(kpiId).then((res) => {
			if (res.status !== 200) return;

			setActions(res.data.data ?? []);
		})
			.catch((error) => {
			});
	};

	const saveData = (e) => {
		setValidated(true);
		e.preventDefault();
		const goalForm = e.currentTarget;
		if (goalForm.checkValidity() === false) {
			e.stopPropagation();
			toast.warning('Please fill all the mandatory fields');
			return;
		}
		setLoaderDisplay(true);
		const fData = JSON.parse(JSON.stringify(formData));
		if (fData.id === 0) {
			delete fData.id;
		}
		KPIService.upsertAction(fData, kpiId).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200 && res.status !== 201) return;

			toast.success("Success", {
				position: toast.POSITION.TOP_RIGHT,
			});
			if (prevMode) {
				setActionMode(prevMode);
				setPrevMode('');
			} else {
				onSave();
			}
		}).catch((error) => {
			setLoaderDisplay(false);
		});
	};

	const onSelectDeSelectUsers = (selectedItem) => {
		const assignees = [...formData.assignees];
		const index = formData.assignees.findIndex(a => a.assigneeId === selectedItem.id);
		if (index >= 0) {
			assignees.splice(index, 1);
		} else {
			assignees.push({
				assigneeId: selectedItem.id,
				assigneeName: selectedItem.name
			});
		}
		setFormData({
			...formData,
			assignees: assignees
		});
	};

	const getSelectedUsers = (assignees) => {
		const data = [];
		assignees?.forEach(a => {
			data.push({ id: a.assigneeId, name: a.assigneeName });
		});
		return data;
	};

	const renderForm = () => {
		return (
			<Form noValidate validated={validated} onSubmit={saveData}>
				<div className="p-2">
					<label className="mb-1">{t("Name.label")} <span className="text-danger">*</span></label>
					<input
						type="text"
						className="form-control"
						onChange={(e) => setFormData({ ...formData, name: e.target.value })}
						value={formData.name}
						required />
				</div>
				<div className="row m-0">
					<div className="col-lg-6 p-2">
						<label className="mb-1">{t('Timeline.label')} <span className="text-danger">*</span></label>
						<ReactDatePicker
							selected={formData.timelineStart ? new Date(formData.timelineStart) : null}
							onChange={(date) => {
								setFormData({
									...formData,
									timelineStart: moment(date).format('YYYY-MM-DD')
								});
							}}
							className="form-control"
							dateFormat="dd/MM/yyyy"
							required />
					</div>
					<div className="col-lg-6 p-2">
						<label className="mb-1">&nbsp;</label>
						<ReactDatePicker
							selected={formData.timelineEnd ? new Date(formData.timelineEnd) : null}
							onChange={(date) => {
								setFormData({
									...formData,
									timelineEnd: moment(date).format('YYYY-MM-DD')
								});
							}}
							className="form-control"
							dateFormat="dd/MM/yyyy"
							required />
					</div>
				</div>
				<div className="p-2">
					<label className="mb-1">
						{t("Assignees.label")}
					</label>
					<Multiselect
						options={users}
						selectedValues={getSelectedUsers(formData.assignees)}
						onSelect={(selectedList, selectedItem) => {
							onSelectDeSelectUsers(selectedItem);
						}}
						onRemove={(selectedList, selectedItem) => {
							onSelectDeSelectUsers(selectedItem);
						}}
						displayValue="name"
						showArrow={false}
					/>
				</div>
				<div className="text-center p-2">
					<Button variant="secondary" className="mx-2" onClick={() => hideModal()}>{t('Cancel.label')}</Button>
					<button type="submit" className="btn btn-primary px-4">{t('Save.label')}</button>
				</div>
			</Form>
		);
	};

	const renderActions = () => {
		return (
			<Table hover className="renderAction_Box m-0">
				<tbody>
					{
						actions?.map((action, aIndex) => {
							return renderAction(action, aIndex);
						})
					}
				</tbody>
			</Table>
		)
	};

	const renderAction = (action, aIndex) => {
		return (

			<tr key={`action-${aIndex}`}>
				<td>
					<div>
						<strong>{action.name}</strong>
					</div>
					<div className="Kpiaction_date">{action.timelineStart ? moment(action.timelineStart).format('MMM DD, YYYY') : ''} - {action.timelineEnd ? moment(action.timelineEnd).format('MMM DD, YYYY') : ''}</div>
				</td>
				<td>
					<div className="renderAction_avatar">
						{
							action.assignees?.map(assignee => {
								return (
									<div className="renderAction_avatar_Single">
										<span className="avatar">
											{Utils.getTextBasedProfilePic(assignee.assigneeName)}
										</span>
										<span className="ps-1">{assignee.assigneeName}</span>
									</div>
								);
							})
						}
					</div>
				</td>
				<td>
					<Button variant="blank_outline"  onClick={() => onEditAction(action)}>
						<BiEdit />
					</Button>
				</td>
			</tr>



		);
	}

	const onEditAction = (action) => {
		setActionMode(ActionMode.FORM);
		setFormData(action);
		setPrevMode(ActionMode.VIEW_ACTIONS);
	};

	const hideModal = () => {
		if (prevMode) {
			setActionMode(prevMode);
			setPrevMode('');
		} else {
			onHide();
		}
	};

	return (
		<>
			<Modal show={true} onHide={() => onHide()}
				aria-labelledby="contained-modal-title-vcenter"
				size="lg"
				centered>
				<Modal.Header closeButton className="border-0">
					< Modal.Title as="h5">
						{
							actionMode === ActionMode.VIEW_ACTIONS ? t('Actions.label') : actionMode === ActionMode.SINGLE_ACTION
								? t('ActionInfo.label') : actionToUpdate?.id > 0
									? t('UpdateAction.label') : t('AddAction.label')
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="">
					{
						actionMode === ActionMode.VIEW_ACTIONS ? renderActions() : actionMode === ActionMode.SINGLE_ACTION
							? renderAction(actionToUpdate, 0) : renderForm()
					}
				</Modal.Body>
			</Modal>
		</>
	);
}

export default withTranslation()(KPIActionModal);

